import React, { FunctionComponent } from 'react';

export type MortgageType = 'Annuïteiten' | 'Linear';

export interface MortgageTypeCardProps {
    label: string;
    description: string;
    name: string;
    checked?: boolean;
    defaultValue?: any;
    id: string;
    register?: any;
    validation?: any;
    onClick?: (value: any, label: string, name: string) => void;
}

export const MortgageTypeCard: FunctionComponent<MortgageTypeCardProps> = ({
    id,
    name,
    description,
    validation,
    register,
    checked,
    defaultValue,
    label,
    onClick = () => {},
}) => {
    return (
        <div className="c-mortgage-type-card">
            <input
                className="mortgage-type-card__input"
                id={id}
                {...register(name, validation ? validation : {})}
                defaultChecked={checked}
                defaultValue={defaultValue}
                type="radio"
            />

            <label
                className="mortgage-type-card__label"
                htmlFor={id}
                onClick={() => onClick(defaultValue, label, name)}>
                <span className="mortgage-type-card__label-title">{label}</span>
                <span className="mortgage-type-card__label-text">{description}</span>
            </label>
        </div>
    );
};

export const MortgageTypeCardWrapper: FunctionComponent = ({ children }) => (
    <div className="mortgage-type-card__wrapper">{children}</div>
);
